<template>
	<div id="home-about-us">
		<div class="natrix-illustration-wrapper">
			<div class="illustration-container">
				<img class="natrix-web-illustration" src="/images/elements/home/web/about-us-illustration.png"
					alt="natrix-illustration" :style="{ transform: customTransform }" />
			</div>
		</div>
		<div class="content-container">
			<div class="content-inner">
				<div class="container">
					<div class="content-section">
						<div class="title headline-l" v-html="$t('homeScreen.aboutUs.title')"></div>
						<div class="natrix-illustration-mobile-wrapper">
							<img class="natrix-mobile-illustration"
								src="/images/elements/home/web/about-us-illustration.png"
								alt="natrix-mobile-illustration" />
						</div>
						<div class="bottom-section">
							<div class="subscription" v-html="$t('homeScreen.aboutUs.description')">
							</div>
							<base-button class="join-button" :text="$t('homeScreen.aboutUs.buttonText')" size="large"
								type="light-green" @clicked="handleClick" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import HomeBlockStockDiagram from './HomeBlockStockDiagram';

export default {
	name: 'HomeAboutUs',
	props: {
		title: {
			type: String,
		},
		description: {
			type: String,
		},
		imagePath: {
			type: String,
		},
		buttonText: {
			type: String,
		},
		customTransform: {
			type: String,
			default: '',
		},
	},
	components: {
		HomeBlockStockDiagram,
	},
	data: () => ({}),
	created() { },
	computed: {},
	methods: {
		handleClick() {
			this.$emit('buttonClicked');
		},
	},
};
</script>

<style lang="scss" scoped>
#home-about-us {
	height: 482px;
	width: 100%;
	border-bottom: 1px solid #6464FF;

	@media (max-width: $breakpoint-md) {
		height: fit-content;
	}

	.natrix-illustration-mobile-wrapper {
		justify-content: center;
		display: flex;
		margin-bottom: $margin-s;
		height: 327px;
		width: 100%;

		@media (min-width: $breakpoint-md) {
			display: none;
		}

		.natrix-mobile-illustration {
			height: 327px;
			width: 100%;
			object-fit: cover;

		}
	}

	.natrix-illustration-wrapper {
		height: 482px;
		width: 100%;
		position: absolute;
		align-items: center;
		display: flex;

		@media (max-width: $breakpoint-md) {
			display: none;
		}

		.natrix-web-illustration {
			position: absolute;
			z-index: 1;
			right: 0;
			height: 482px;
			width: 611px;
			object-fit: cover;

			@media (max-width: $breakpoint-lg) {
				width: 500px;
			}

			@media (max-width: $breakpoint-xs) {
				position: relative;
			}
		}
	}

	.illustration-container {
		height: 482px;
		display: flex;
		align-items: center;
		position: relative;
		width: 100%;
	}

	.container {
		@media (min-width: $breakpoint-lg) {
			max-width: 1196px;
		}

		@media (max-width: $breakpoint-xs) {
			padding-left: 0px;
			padding-right: 0px;
		}
	}

	.content-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
		height: 100%;

		// background: linear-gradient(to left, transparent, #050533 40%);
		@media (max-width: $breakpoint-md) {
			// background: rgba(5, 5, 53, 0.6);
		}

		.content-inner {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			z-index: 1;

			.content-section {
				.title {
					max-width: 630px;
					margin-bottom: 40px;
					letter-spacing: 0em;
					text-align: left;
					text-transform: uppercase;

					@media (max-width: $breakpoint-lg) {
						max-width: 460px;
					}

					@media (max-width: $breakpoint-md) {
						text-align: center;
						max-width: unset;
					}
				}

				.bottom-section {
					@media (max-width: $breakpoint-xs) {
						padding-left: 15px;
						padding-right: 15px;
					}
				}

				.subscription {
					max-width: 630px;
					margin-bottom: 40px;
					font-size: 16px;
					font-weight: 400;
					line-height: 30px;
					letter-spacing: 0em;
					text-align: left;

					@media (max-width: $breakpoint-lg) {
						max-width: 460px;
					}

					@media (max-width: $breakpoint-md) {
						text-align: center;
						max-width: unset;
					}
				}

				.join-button {
					text-transform: uppercase;
					@media (max-width: $breakpoint-md) {
						width: 100%;
					}
				}
			}
		}
	}
}

@media (max-width: $breakpoint-md) {
	#home-about-us {
		.content-container {
			padding-top: $margin-m;
			padding-bottom: 80px;
		}
	}
}
</style>
